import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DomainAuthService } from 'src/app/private/services/domainauth.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-add-auth-domain',
  imports: [SharedModule],
  templateUrl: './add-auth-domain.component.html',
  styleUrl: './add-auth-domain.component.scss'
})
export class AddAuthDomainComponent {

  domain: string = '';
  spf: any = null;
  dkim: any[] = [];
  isAddDomain: boolean = true;
  isShowDetails: boolean = false;
  btnLoading: boolean = false;
  @Input() isShowEditDetails: boolean = false;
  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();

  @Input() type: 'Add' | 'View' = 'Add';
  @Input() domainData: any;
  alreadyVerified: boolean = false;

  constructor(
    private domainAuthService: DomainAuthService,
    private localStorage: LocalStorageService,
    private messageService: MessageService,
  ) { }

  ngOnInit() {
    if (this.type == 'View') {
      this.dkim = this.domainData.dkim_tokens || [];
      this.domain = this.domainData.domain || '';
      this.spf = this.domainData.spf_token || null;
      this.isAddDomain = false;
      this.isShowDetails = false;
      this.isShowEditDetails = true;
    }
  }

  initDomainAuth(response: any) {
    this.domain = response.domain;
    this.spf = response.spf;
    this.dkim = response.dkim;
    this.isAddDomain = false;
    this.isShowDetails = true;
  }

  submitDomainAuth() {
    const payload = {
      organization_id: this.localStorage.getOrganizationId(),
      domain: this.domain
    };

    this.btnLoading = true;
    this.domainAuthService.authenticateClientDomain(payload).subscribe({
      next: (response) => {

        if(response.message == "Domain already verified.") {
          this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Domain is already verified.' });
          this.btnLoading = false;
          this.alreadyVerified = true;
          return;
        }else{
          this.alreadyVerified = false;
        }

        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Domain authentication initiated successfully.' });
        this.isAddDomain = false;
        this.isShowDetails = true;
        this.initDomainAuth(response);

        this.btnLoading = false;
      },
      error: (error) => {
        console.error('Error during domain authentication:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to initiate domain authentication. Please try again.' });
        this.btnLoading = false;
      }
    });
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      // Optional: Show success message
      this.messageService?.add({
        severity: 'success',
        summary: 'Copied',
        detail: 'Value copied to clipboard'
      });
    });
  }

  closeModal() {
    this.close.emit();
    this.reload.emit();
  }

}
